import { Box, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',height:'89vh',flexDirection:'column',gap:5}}>
      <Typography variant='h4' sx={{color:'red'}}>
        Page Not Found
      </Typography>
      <Typography variant='h6'>
        Please go to {" "}
        <Link to={'/'} style={{textDecoration:'none',color:'green'}}>Home Page</Link>
      </Typography>
    </Box>
  )
}

export default NotFound